module.exports = __webpack_public_path__ + "static/media/timer-ballon.138f6f3e.svg";